import type { ReactNode } from 'react';

/**
 * The honest empty state.
 *
 * Used wherever a surface has nothing real to show. CLAUDE_MASTER_PROMPT.md
 * forbids faking incoming messages or implying an integration exists, so these
 * say plainly what is not yet available rather than filling space with
 * placeholder data.
 */
export function EmptyState({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): React.JSX.Element {
  return (
    <div className="empty">
      <h3 className="empty__title">{title}</h3>
      <div className="empty__body">{children}</div>
    </div>
  );
}
